module.exports = __webpack_public_path__ + "media/images/invoice_logo-b0ffcf90689b27f8ddff1e77d187e3d2.svg";